<div id="blackBox">
  <img id="searchImg" src="../../../assets/images/case_search.svg" alt="search fasfsfbox tool">
  <div class="filter_text">
    <input type="text" id="searchBox" [(ngModel)]="searchValue" (change)="searchData($event.target.value)"
      placeholder="Enter first or last name...">
  </div>
</div>
<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}} </td>
  </ng-container>
  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element"> {{element.birthDate | date:'MM/dd/yyyy'}} ({{element.age}})</td>
  </ng-container>
  <ng-container matColumnDef="treatmentStatus">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element"> {{element.treatmentStatusName}}</td>
  </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button class="action-btn" (click)="openModal(PatientDetailsArea.Financial, element)">GO</button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #pagination [length]="paginator.length" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 75,100]"
  (page)="onPaginateChange($event)">
</mat-paginator>
